import React, { Fragment } from 'react';

const MapRoute = ({ src }) => (
  <>
    <iframe src={src} width="100%" height="100%" />
    <style jsx>{`
      iframe {
        border: 0;
      }
    `}</style>
  </>
);

export default MapRoute;
